module.exports = __webpack_public_path__ + "static/media/CVI.01b8c808.pdf";